import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  TextField,
  BooleanInput,
  BooleanField,
  SelectInput,
  ReferenceInput,
  required,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';

export const PspList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="name" />
      <BooleanField source="active" />
      <EditButton {...props} basePath="/psps" />
      <DeleteButton {...props} basePath="/psps" />
    </Datagrid>
  </List>
);

export const PspEdit = (props) => (
  <Edit title="Edit" {...props}>
    <SimpleForm {...props}>
      <TextInput source="name" />
      <ReferenceInput format={(account) => account && account._id} source="account" reference="accounts" perPage={9999} allowEmpty validate={[required]}>
        <SelectInput optionText="name" optionValue="id" options={{ fullWidth: true }} validate={[required]} />
      </ReferenceInput>
      <BooleanInput source="active" />
    </SimpleForm>
  </Edit>
);

export const PspCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" />
      <ReferenceInput format={(account) => account && account._id} source="account" reference="accounts" perPage={9999} allowEmpty validate={[required]}>
        <SelectInput optionText="name" optionValue="id" options={{ fullWidth: true }} validate={[required]} />
      </ReferenceInput>
      <BooleanInput source="active" />
    </SimpleForm>
  </Create>
);
